/* Larrysa's Bakery: referência de pedido nas mensagens de WhatsApp.
   Formato configurável em REF_CONFIG (agora LBW-aammdd-XXXX). Criada ao abrir o WhatsApp e reutilizada na mesma sessão para o mesmo pedido.
   Mostra a data como "Para quando precisa" (vazia se faltar) e acrescenta a linha Nome antes do fecho.
   26 Out 2026: só recolha na Pontinha; linhas antigas de zona ou morada são retiradas. */
(function () {
  if (window.LarrysaWaRef) return;
  /* Formato da referência: mudar só aqui.
     {prefix} prefixo, {yy}{mm}{dd} data do pedido, {rand} caracteres aleatórios do alfabeto.
     Nota: o Bakery Assist usa LB-AAAA-NNNN (sequencial); o site usa LBW até decisão. */
  var REF_CONFIG = { prefix: 'LBW', format: '{prefix}-{yy}{mm}{dd}-{rand}', randomLength: 4, alphabet: '23456789ABCDEFGHJKMNPQRSTUVWXYZ' };
  var ALPHABET = REF_CONFIG.alphabet;
  var KEY = 'larrysa:wa-ref:v2';
  var OPENINGS = [/^Olá, Larrysa's Bakery!/, /^Hello, Larrysa's Bakery!/];
  var REF_LINE = /^\*(?:Pedido|Order):\*\s*(\S+)\s*$/;
  var FILL_LINE = /^\*(?:Nome|Name|Zona ou morada|Area or address|Para quando precisa|Needed by):\*\s*$/;
  var ZONE_LINE = /^\*?(?:Zona de entrega|Zona de entrega \(se aplicável\)|Delivery area|Zona ou morada|Area or address|Localidade):/;
  var DATE_LINE = /^\*?(?:Data pretendida|Data|Date|Preferred date|Para quando precisa|Needed by):\*?\s*(.*)$/;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function random4() {
    var n = REF_CONFIG.randomLength, out = '', buf = new Uint32Array(n);
    try { crypto.getRandomValues(buf); } catch (e) { for (var j = 0; j < n; j++) buf[j] = Math.floor(Math.random() * 4294967296); }
    for (var i = 0; i < n; i++) out += ALPHABET.charAt(buf[i] % ALPHABET.length);
    return out;
  }
  function newRef() {
    var d = new Date();
    var parts = { prefix: REF_CONFIG.prefix, yyyy: String(d.getFullYear()), yy: pad(d.getFullYear() % 100), mm: pad(d.getMonth() + 1), dd: pad(d.getDate()), rand: random4() };
    return REF_CONFIG.format.replace(/\{(\w+)\}/g, function (all, k) { return parts[k] != null ? parts[k] : all; });
  }
  function store() { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(map) { try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {} }

  function signature(lines) {
    var first = lines[0] || '';
    var kind = /orçamento para uma festa|quote for a party/.test(first) ? 'festa'
      : /esclarecer algumas questões|ask a few questions/.test(first) ? 'duvidas' : 'encomenda';
    var titles = [];
    lines.forEach(function (line) {
      var m = /^\*(?:\d+\.\s*)?([^*:]+)\*(?:\s|$)/.exec(line);
      if (m) titles.push(m[1].trim().toLowerCase());
    });
    if (kind === 'duvidas') lines.forEach(function (line) { var m = /^(.+?) · (?:Quantidade|Quantity):/.exec(line); if (m) titles.push(m[1].trim().toLowerCase()); });
    titles.sort();
    return kind + '|' + titles.join('|');
  }
  function refFor(sig) {
    var map = store();
    if (!map[sig]) { map[sig] = newRef(); save(map); }
    return map[sig];
  }

  function isOrderMessage(text) {
    if (!text) return false;
    var first = text.split('\n')[0];
    if (!OPENINGS.some(function (re) { return re.test(first); })) return false;
    return /\n\*[^*\n]+\*/.test(text);
  }


  function decorate(text) {
    if (!isOrderMessage(text)) return text;
    var en = /^Hello/.test(text);
    var lines = text.replace(/\r\n/g, '\n').split('\n');
    var existing = null;
    lines = lines.filter(function (line) {
      var m = REF_LINE.exec(line);
      if (m) { existing = m[1]; return false; }
      return !FILL_LINE.test(line) && !ZONE_LINE.test(line);
    });
    var hasDate = false;
    lines = lines.map(function (line) {
      var m = DATE_LINE.exec(line);
      if (!m || !m[1].trim()) return line;
      hasDate = true;
      return '*' + (en ? 'Needed by' : 'Para quando precisa') + ':* ' + m[1].trim();
    });
    var body = lines.join('\n').replace(/\n{3,}/g, '\n\n').replace(/\s+$/, '');
    lines = body.split('\n');
    var ref = existing || refFor(signature(lines));
    var fill = [];
    if (!hasDate) fill.push('*' + (en ? 'Needed by' : 'Para quando precisa') + ':* ');
    fill.push('*' + (en ? 'Name' : 'Nome') + ':* ');

    var blocks = body.split('\n\n');
    var opening = blocks.shift();
    var closing = blocks.length ? blocks.pop() : '';
    var out = [opening, '*' + (en ? 'Order' : 'Pedido') + ':* ' + ref].concat(blocks, [fill.join('\n')]);
    if (closing) out.push(closing);
    return out.join('\n\n');
  }

  function decorateUrl(href) {
    try {
      var url = new URL(href, location.href);
      if (!/(^|\.)wa\.me$/.test(url.hostname) && !/whatsapp\.com$/.test(url.hostname)) return href;
      var text = url.searchParams.get('text');
      var next = decorate(text);
      if (!text || next === text) return href;
      url.searchParams.set('text', next);
      return url.toString().replace(/\+/g, '%20');
    } catch (e) { return href; }
  }

  function onActivate(event) {
    var a = event.target && event.target.closest && event.target.closest('a[href*="wa.me/"],a[href*="whatsapp.com/"]');
    if (!a || a.getAttribute('aria-disabled') === 'true') return;
    /* 27 Out 2026: o botão do hero já leva a mensagem final (data e alergias); não acrescentar referência nem Nome. */
    if (a.hasAttribute('data-wa-keep')) return;
    var next = decorateUrl(a.href);
    if (next !== a.href) a.href = next;
  }
  document.addEventListener('click', onActivate, true);
  document.addEventListener('auxclick', onActivate, true);
  document.addEventListener('contextmenu', onActivate, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !/wa\.me\//.test(form.action || '')) return;
    var field = form.querySelector('[name="text"]');
    if (field) field.value = decorate(field.value);
  }, true);

  var nativeOpen = window.open;
  window.open = function (href) {
    var args = Array.prototype.slice.call(arguments);
    if (typeof href === 'string' || (href && href.href)) args[0] = decorateUrl(String(href));
    return nativeOpen.apply(window, args);
  };

  window.LarrysaWaRef = { config: REF_CONFIG, decorate: decorate, decorateUrl: decorateUrl, newRef: newRef };
})();
